import store from '@/store'

/**
 * Created by Fernando Torres on 22/03/2018.
 */

export default {
  onQueryEvaluate (to, from, next) {
    store.dispatch('evaluations/get', {
      id: to.params.id,
      with: 'assignment'
    }).then(({
      data
    }) => {
      let promises = []
      promises.push(store.dispatch('layouts/get', {
        id: data.layoutId
      }))
      promises.push(store.dispatch('assignments/get', {
        id: data.assignmentId,
        with: 'layout, period'
      }))
      promises.push(store.dispatch('branches/get', {
        id: data.branchId,
        with: 'dealer'
      }))
      Promise.all(promises).then(() => {
        next()
      }).catch(error => {
        next(error)
      })
    }).catch(error => {
      next(error)
    })
  },
  onQuery (to, from, next) {
    store.dispatch('evaluations/get', {
      id: to.params.id,
      with: 'branch, dealer, period, layout, config'
    }).then(({
      data
    }) => {
      store.dispatch('layouts/get', {
        id: data.layoutId
      }).then(({
        data
      }) => {
        // SECTIONS
        store.dispatch('sections/query', {
          'filters[whereNull]': 'parentId',
          'filters[where][layoutId][eq]': data.id,
          sort: 'index asc',
          limit: 1000
        }).then(response => {
          let ids = []
          for (let section of response.data.items) {
            ids.push(section.id)
          }
          // SUBSECTIONS
          store.dispatch('subsections/query', {
            'filters[whereIn][parentId]': ids,
            sort: 'index asc',
            limit: 1000
          }).then(responseSubsection => {
            for (let subsection of responseSubsection.data.items) {
              ids.push(subsection.id)
            }
            // QUESTIONS
            store.dispatch('questions/query', {
              'filters[whereIn][sectionId]': ids,
              sort: 'index asc',
              limit: 1000
            }).then(response => {
              // ANSWERS
              let questionIds = []
              for (let question of response.data.items) {
                questionIds.push(question.id)
              }
              store.dispatch('answers/query', {
                'filters[whereIn][questionId]': questionIds,
                sort: 'index desc',
                limit: 1000
              }).then(response => {
                // POINTS
                store.dispatch('points/query', {
                  'filters[whereIn][questionId]': questionIds,
                  sort: 'type asc',
                  limit: 1000
                }).then(response => {
                  next(response)
                })
                // END POINTS
              })
              // END ANSWERS
            })
            // END QUESTIONS
          })
          // END SUBSECTIONS
        })
        // END SECTIONS
      })
    }).catch(error => {
      next(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/guards/evaluation.guards.js